import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from './admin.component';
import { LoginComponent } from './login.component';
import { MainComponent } from './main.component';
import { MygearComponent } from './mygear.component';
import { PoolComponent } from './pool.component';
import { ResetPasswordComponent } from './reset/reset-password.component';
import { SendEmailComponent } from './reset/send-email.component';
import { ShowgearComponent } from './showgear.component';
import { SignupComponent } from './signup.component';
import { WelcomeComponent } from './welcome.component';

const routes: Routes = [{path: '', component: WelcomeComponent},
                        {path: 'login', component: LoginComponent},
                        {path: 'signup', component: SignupComponent},
                        {path: 'main', component: MainComponent},
                        {path: 'mygear', component: MygearComponent},
                        {path: 'allgear', component: PoolComponent},
                        {path: 'showgear/:id', component: ShowgearComponent},
                        {path: 'admin', component: AdminComponent},
                        {path: 'reset', component: SendEmailComponent},
                        {path: 'resetpass/:token', component: ResetPasswordComponent}];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
